<template>
  <v-row>
    <v-col cols="12" class="pt-0">
      <v-sheet>
        <v-row>
          <v-col cols="12">
            <v-row
              align="center"
              justify="center"
            >
              <v-progress-circular
                :size="100"
                :width="5"
                color="primary"
                class="my-5"
                indeterminate
              />
            </v-row>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>
  </v-row>
</template>
<script>
import CustomerCards from "../Customer/CustomerCards"
import AccountSubscription from '@/components/Account/AccountSubscription'

export default {
  components: {
    AccountSubscription
  },
  data() {
    return {
      isLoading: false
    }
  },
  mounted() {
    this.isLoading = true
  }
}
</script>
